module.exports = __webpack_public_path__ + "img/technology-base.62dc04e8.png";